import React from 'react'
import { TextField } from 'react-admin'
import Exporter from 'services/csv/exporter'
import CatalogItemBaseList, {
  CatalogItemBaseListProps,
} from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const LocationFeatureList: React.FC<CatalogItemBaseListProps> = (props) => (
  <CatalogItemBaseList {...props} exporter={Exporter()}>
    <TextField source="category" label="Item Type" />
  </CatalogItemBaseList>
)

export default LocationFeatureList
